if (!window.Eurus.loadedScript.has('faq-search.js')) {
  window.Eurus.loadedScript.add('faq-search.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFaqSearch', (stickyOffset) => ({
        query: '',
        categories: [],
        activeCategoryId: '',
        noResults: false,
        stickyOffset: stickyOffset || 0,

        init() {
          this.$nextTick(() => {
            this.discoverSections();
          });
        },

        get visibleCategories() {
          return this.categories.filter((category) => category.visible);
        },

        discoverSections() {
          const sections = document.querySelectorAll('.section-faq');
          this.categories = [];

          sections.forEach((section) => {
            const anchor = section.querySelector('[id^="faq-section-"]');
            const heading = section.querySelector('.x-block-faq-header h1, .x-block-faq-header h2, .x-block-faq-header h3, .x-block-faq-header h4, .x-block-faq-header .h2');
            if (!anchor || !heading) return;

            const title = heading.textContent.trim();
            if (!title) return;

            this.categories.push({
              id: anchor.id,
              title: title,
              visible: true
            });
          });
        },

        filterFaqs() {
          const query = this.query.trim().toLowerCase();
          const active = query.length > 0;

          document.body.classList.toggle('faq-search-active', active);

          let matchCount = 0;
          const sectionMatches = {};

          document.querySelectorAll('.section-faq').forEach((section) => {
            let sectionHasMatch = false;
            const anchor = section.querySelector('[id^="faq-section-"]');

            section.querySelectorAll('.faq-item').forEach((item) => {
              const questionEl = item.querySelector('.faq-collapsible p.font-medium, .faq-collapsible > p');
              const answerEl = item.querySelector('.faq-content');
              const question = questionEl?.textContent?.trim().toLowerCase() || '';
              const answer = answerEl?.textContent?.trim().toLowerCase() || '';
              const matches = !active || question.includes(query) || answer.includes(query);

              item.classList.toggle('faq-item--hidden-by-search', active && !matches);
              item.classList.toggle('faq-item--search-match', active && matches);

              if (matches) {
                sectionHasMatch = true;
                matchCount += 1;
              }
            });

            section.classList.toggle('faq-section--hidden-by-search', active && !sectionHasMatch);

            if (anchor?.id) {
              sectionMatches[anchor.id] = sectionHasMatch;
            }
          });

          this.categories.forEach((category) => {
            category.visible = !active || !!sectionMatches[category.id];
          });

          this.noResults = active && matchCount === 0;
        },

        clearSearch() {
          this.query = '';
          this.filterFaqs();
        },

        scrollToSection(id) {
          const el = document.getElementById(id);
          if (!el) return;

          this.activeCategoryId = id;

          const offset = this.stickyOffset;
          const top = el.getBoundingClientRect().top + window.scrollY - offset;

          window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        }
      }));
    });
  });
}
